import { levenshteinPercentage } from "./helpers/algorithms";

// from: https://stackoverflow.com/a/54272512
let keyName: string;
export const iterateObject = (obj: any, label: string) => {
    Object.keys(obj).forEach((key) => {

        if (typeof obj[key] === 'string') {
            if (levenshteinPercentage(label.toLowerCase(), obj[key].toLowerCase()) > 0.85) {
                keyName = key;
            }
        }

        if (typeof obj[key] === 'object' && obj[key] !== null) {
            iterateObject(obj[key], label);
        }
    });

    return keyName;
};

// from: https://stackoverflow.com/a/58895906
export const findObjectPath = (obj: any, name: any, val: any, currentPath?: any): any => {
    currentPath = currentPath || '';

    let matchingPath;

    if (!obj || typeof obj !== 'object') return;

    if (typeof obj[name] !== 'undefined' && typeof val !== 'undefined') {
        if (levenshteinPercentage(obj[name]?.toLowerCase(), val.toLowerCase()) > 0.85) {
            return `${currentPath}.${name}`;
        }
    }

    if (obj[name] === val) return `${currentPath}.${name}`;

    for (const key of Object.keys(obj)) {
        if (key === name && obj[key] === val) {
            matchingPath = currentPath;
        } else {
            matchingPath = findObjectPath(obj[key], name, val, `${currentPath}.${key}`);
        }

        if (matchingPath) break;
    }

    return matchingPath;
};